import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './FoodstationLP.css';

import logo from './foodstation.png';
import card1 from './1.PNG';
import card2 from './2.PNG';
import card4 from './4.PNG';
import card5 from './5.PNG';
import card6 from './6.PNG';
// import card7 from './7.PNG'; // Smart Campaigns ainda nao vai ter.
import SupportChat from './SupportChat';
import SessionExpiryNotice from '../common/SessionExpiryNotice';
import { FOODSTATION_TRIAL_PRODUCTS } from '../../utils/productDisplayCatalog';
import { getPublicProductCatalog } from '../../services/api';
import { SALES_WHATSAPP_LINK } from '../../utils/whatsapp';
import { ATENDABOT_PRODUCT_IMAGE, PRODUCT_IMAGES } from '../../branding/assets';

const galleryCards = [
  { src: card1, alt: 'Atendabot' },
  { src: card6, alt: 'Reservo' },
  { src: card4, alt: 'Currículo' },
  { src: PRODUCT_IMAGES.oneMenu, alt: 'One Menu', className: 'logo-slider__item--logo' },
  { src: card2, alt: 'Feedback' },
  // { src: card7, alt: 'Smart' }, // Smart Campaigns ainda nao vai ter.
];

const promoRepeats = Array.from({ length: 8 }, (_, index) => index);

const productShowcase = [
  {
    title: 'Atendabot',
    priceKey: 'atendabot',
    signupProductKey: 'atendabot',
    priceBenefit: 'Combo completo: AtendaBot + One Menu',
    layout: 'feature',
    logo: ATENDABOT_PRODUCT_IMAGE,
    logoWidth: '200px',
    logoMarginBottom: '12px',
    headline: 'Chega de perder vendas por falta de atendimento',
    description:
      'Atenda seus clientes de forma rápida, organizada e automática no WhatsApp, mantendo um atendimento humanizado e sem sobrecarregar sua equipe.',
    highlights: [
      'Assistente inteligente',
      'Reconhecimento de áudio',
      'Atendimento 24/7',
      'Do pedido à cozinha',
    ],
    images: ['/lp/atendabot0.jpeg', '/lp/atendabot2.jpeg'],
    videoUrl: 'https://youtu.be/Ne1WH0rcxgM',
    image: card1,
    alt: 'Atendabot',
    anchor: 'atendabot',
    reverse: false,
    theme: {
      bg: '#3b3296',
      text: '#f5f3ff',
      muted: 'rgba(255, 255, 255, 0.78)',
      card: '#38259e',
      cardBorder: 'rgba(255, 255, 255, 0.12)',
      shadow: '0 20px 45px rgba(10, 6, 45, 0.45)',
    },
  },
  {
    title: 'Reservo',
    priceKey: 'reservo',
    signupProductKey: 'reservo',
    layout: 'feature',
    logo: PRODUCT_IMAGES.reservo,
    logoClass: 'product-logo--reservo',
    logoWidth: '225px',
    logoMarginBottom: '25px',
    headline: 'Não perca mais mesas por falhas na organização',
    description:
      'Centralize suas reservas, visualize a ocupação do salão em tempo real e organize o fluxo de clientes sem planilhas, mensagens perdidas ou confusão na porta.',
    highlights: [
      'Reservas organizadas',
      'Visão do salão',
      'Menos no-show',
      'Fluxo controlado',
    ],
    images: ['/lp/reservo1.jpeg', '/lp/reservo2.PNG', '/lp/reservo3.PNG'],
    videoUrl: 'https://youtu.be/1KaSXtyebG8',
    image: card6,
    alt: 'Reservo',
    anchor: 'reservo',
    reverse: true,
    theme: {
      bg: '#fadc3f',
      text: '#2a1f12',
      muted: '#534532',
      card: '#fadc3f',
      cardBorder: 'rgba(0, 0, 0, 0.1)',
      shadow: '0 18px 36px rgba(116, 84, 0, 0.35)',
    },
  },
  {
    title: 'Currículo Certo',
    priceKey: 'curriculo_certo',
    signupProductKey: 'cv',
    layout: 'feature',
    logo: PRODUCT_IMAGES.cv,
    logoClass: 'product-logo--curriculo',
    logoWidth: '160px',
    logoMarginBottom: '20px',
    headline: 'Contrate melhor sem perder tempo',
    description:
      'Automatize a triagem de candidatos, filtre perfis certos desde o início e foque apenas em quem realmente faz sentido para sua operação.',
    highlights: [
      'Triagem automática',
      'Filtro inteligente',
      'Menos tempo perdido',
      'Contratação assertiva',
    ],
    images: ['/lp/curriculo1.jpeg', '/lp/curriculo2.PNG'],
    videoUrl: 'https://youtu.be/KQMUwrBk0Kg',
    image: card4,
    alt: 'Currículo Certo',
    anchor: 'cv',
    reverse: true,
    theme: {
      bg: '#000',
      text: '#f5f5f5',
      muted: '#b9b9b9',
      card: '#000000',
      cardBorder: 'rgba(255, 255, 255, 0.12)',
      shadow: '0 20px 45px rgba(0, 0, 0, 0.6)',
    },
  },
  {
    title: 'One Menu',
    priceKey: 'atendabot',
    signupProductKey: 'atendabot',
    priceBenefit: 'Incluído no combo com o AtendaBot',
    layout: 'feature',
    logo: PRODUCT_IMAGES.oneMenu,
    logoWidth: '200px',
    logoMarginBottom: '10px',

    headline: 'Cardápio confuso custa pedidos todos os dias',
    description:
      'Tenha um cardápio digital rápido, bonito e sempre atualizado. No salão, o cliente acessa pelo QR Code. No WhatsApp, escolhe os pratos sem erro - menos perguntas, mais pedidos e mais agilidade na operação.',
    highlights: [
      'Cardápio digital',
      'QR Code no salão',
      'Pedido fácil',
      'Mais conversão',
    ],
    images: ['/lp/onemenu1.jpeg', '/lp/onemenu2.PNG'],
    videoUrl: 'https://youtu.be/evVtCqTg-EU',
    image: card5,
    alt: 'One Menu',
    anchor: 'onemenu',
    reverse: false,
    theme: {
      bg: '#fef5f3',
      text: '#2a211d',
      muted: '#6c5f58',
      card: '#ffffff',
      cardBorder: 'rgba(0, 0, 0, 0.08)',
      shadow: '0 18px 36px rgba(0, 0, 0, 0.12)',
    },
  },
  {
    title: 'Feedback Hero',
    priceKey: 'feedback_hero',
    signupProductKey: 'feedback_hero',
    layout: 'feature',
    logo: PRODUCT_IMAGES.feedbackHero,
    logoWidth: '200px',    
    logoMarginBottom: '-30px',
    headline: 'Conheça seu cliente de verdade',
    description:
      'Centralize feedbacks, entenda a experiência real do cliente e transforme opiniões soltas em decisões claras para melhorar o atendimento e a operação.',
    highlights: [
      'Feedback centralizado',
      'Análise inteligente',
      'Decisão baseada em dados',
      'Melhoria contínua',
    ],
    images: ['/lp/feed3.PNG', '/lp/feed2.jpeg'],
    videoUrl: 'https://youtu.be/X7vHtgbtOG8',
    image: card2,
    alt: 'Feedback Hero',
    anchor: 'feedback',
    reverse: true,
    theme: {
      bg: '#172f23',
      text: '#f2fff6',
      muted: '#c9e2d3',
      card: '#183023',
      cardBorder: 'rgba(255, 255, 255, 0.12)',
      shadow: '0 18px 36px rgba(0, 0, 0, 0.5)',
    },
  },
  {
    title: 'ClientCenter CRM',
    included: true,
    layout: 'feature',
    logo: PRODUCT_IMAGES.clientCenterDark,
    logoClass: 'product-logo--clientcenter',
    logoWidth: '300px',
    logoMarginBottom: '8px',
    headline: 'Transforme cada interação em relacionamento',
    description:
      'Reúna o histórico dos seus clientes em uma visão única e use dados de reservas, pedidos e feedbacks para entender quem compra, quem voltou e quem precisa ser reconquistado.',
    highlights: [
      'Histórico unificado do cliente',
      'Reservas, pedidos e feedbacks conectados',
      'Base própria e organizada',
      'Mais contexto para fidelizar',
    ],
    brandVisual: 'crm',
    alt: 'ClientCenter CRM',
    anchor: 'crm',
    sectionId: 'incluidos',
    reverse: false,
    theme: {
      bg: '#101927',
      text: '#f4fbf8',
      muted: '#b9c9c2',
      card: '#162233',
      cardBorder: 'rgba(67, 214, 155, 0.28)',
      shadow: '0 22px 48px rgba(2, 8, 18, 0.55)',
    },
  },
  {
    title: 'LinkPage',
    included: true,
    layout: 'feature',
    logo: PRODUCT_IMAGES.linkPage,
    logoClass: 'product-logo--linkpage',
    logoWidth: '245px',
    logoMarginBottom: '6px',
    headline: 'Um único link para tudo que seu cliente procura',
    description:
      'Organize seus principais canais em uma página fácil de compartilhar. Cardápio, reservas, avaliações e outros links ficam acessíveis pela bio ou pelo WhatsApp.',
    highlights: [
      'Página personalizada do restaurante',
      'Links e produtos em um só lugar',
      'Pronta para bio e WhatsApp',
      'Experiência simples para o cliente',
    ],
    brandVisual: 'linkpage',
    alt: 'LinkPage',
    anchor: 'linkpage',
    reverse: true,
    theme: {
      bg: '#eef0f2',
      text: '#18191c',
      muted: '#5d626b',
      card: '#ffffff',
      cardBorder: 'rgba(24, 25, 28, 0.12)',
      shadow: '0 20px 42px rgba(24, 25, 28, 0.18)',
    },
  },
  /*
  {
    title: 'Smart Campaigns',
    layout: 'feature',
    logo: PRODUCT_IMAGES.smartCampaigns,
    logoMarginBottom: '20px',
    headline: 'Venda mais para quem já conhece seu restaurante',
    description:
      'Ative campanhas inteligentes no WhatsApp usando dados reais dos seus clientes. Segmente, comunique e gere recorrência sem depender apenas de anúncios ou redes sociais.',
    highlights: [
      'Campanhas inteligentes',
      'Direto no WhatsApp',
      'Segmentações de clientes',
      'Mais recorrência',
    ],
    images: ['/lp/sc1.jpeg', '/lp/sc2.jpeg'],
    videoUrl: '',
    image: card7,
    alt: 'Smart Campaigns',
    anchor: 'smart',
    reverse: true,
    theme: {
      bg: '#ef7a1f',
      text: '#2b1407',
      muted: '#4b2a12',
      card: '#f56c1f',
      cardBorder: 'rgba(0, 0, 0, 0.08)',
      shadow: '0 18px 36px rgba(114, 46, 0, 0.35)',
    },
  },
  */
];

const salesWhatsappLink = SALES_WHATSAPP_LINK;
const planProductCards = FOODSTATION_TRIAL_PRODUCTS;

const formatProductPrice = (price) => {
  const priceCents = Number(price?.priceCents);
  if (!Number.isInteger(priceCents) || priceCents < 0) return null;

  const currency = String(price?.currency || 'brl').toUpperCase();
  const hasCents = priceCents % 100 !== 0;
  const parts = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency,
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: hasCents ? 2 : 0,
  }).formatToParts(priceCents / 100);

  return {
    currency: parts.find((part) => part.type === 'currency')?.value || currency,
    amount: parts
      .filter((part) => ['integer', 'group', 'decimal', 'fraction'].includes(part.type))
      .map((part) => part.value)
      .join(''),
    interval: String(price?.interval || '').toLowerCase() === 'month' ? '/mês' : '',
  };
};

const ProductPrice = ({ price, status, benefit }) => {
  const formattedPrice = formatProductPrice(price);

  if (status === 'loading') {
    return (
      <div className="product-price product-price--loading" aria-label="Carregando preço atual">
        <span className="product-price-skeleton product-price-skeleton--label" />
        <span className="product-price-skeleton product-price-skeleton--value" />
      </div>
    );
  }

  if (!formattedPrice) {
    return (
      <div className="product-price product-price--unavailable">
        <span className="product-price-eyebrow">Preço atualizado</span>
        <strong>Consulte ao começar</strong>
      </div>
    );
  }

  return (
    <div className="product-price">
      <span className="product-price-eyebrow">Assinatura mensal</span>
      <div className="product-price-value" aria-label={`${formattedPrice.currency} ${formattedPrice.amount} por mês`}>
        <span className="product-price-currency">{formattedPrice.currency}</span>
        <strong>{formattedPrice.amount}</strong>
        <span className="product-price-interval">{formattedPrice.interval}</span>
      </div>
      {benefit ? <span className="product-price-benefit">{benefit}</span> : null}
    </div>
  );
};

const IncludedProductBadge = () => (
  <div className="product-included-badge" aria-label="Incluído gratuitamente">
    <span className="product-included-icon" aria-hidden="true">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path
          d="M20 6L9 17l-5-5"
          stroke="currentColor"
          strokeWidth="2.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
    <span>
      <small>Sem mensalidade adicional</small>
      <strong>Incluído gratuitamente</strong>
    </span>
  </div>
);

const ProductBrandVisual = ({ variant }) => {
  if (variant === 'crm') {
    return (
      <div className="product-brand-visual product-brand-visual--crm" aria-label="Visão ilustrativa do ClientCenter CRM">
        <div className="brand-visual-toolbar">
          <span /><span /><span />
          <strong>Visão do cliente</strong>
        </div>
        <div className="crm-visual-profile">
          <span className="crm-visual-avatar">MC</span>
          <span><strong>Mariana Costa</strong><small>Cliente recorrente</small></span>
          <span className="crm-visual-status">Ativo</span>
        </div>
        <div className="crm-visual-stats">
          <span><strong>12</strong><small>interações</small></span>
          <span><strong>4</strong><small>reservas</small></span>
          <span><strong>5★</strong><small>avaliação</small></span>
        </div>
        <div className="crm-visual-timeline">
          <span><i />Reserva confirmada<small>Hoje</small></span>
          <span><i />Novo pedido realizado<small>8 dias</small></span>
          <span><i />Feedback recebido<small>21 dias</small></span>
        </div>
      </div>
    );
  }

  return (
    <div className="product-brand-visual product-brand-visual--linkpage" aria-label="Visão ilustrativa de uma LinkPage">
      <div className="linkpage-visual-profile">
        <span className="linkpage-visual-avatar">FS</span>
        <strong>Seu restaurante</strong>
        <small>Tudo o que seu cliente precisa</small>
      </div>
      <div className="linkpage-visual-links">
        <span>Ver cardápio <i>↗</i></span>
        <span>Fazer uma reserva <i>↗</i></span>
        <span>Avaliar experiência <i>↗</i></span>
      </div>
      <small className="linkpage-visual-address">foodstation.app/links/seu-restaurante</small>
    </div>
  );
};

const plans = [
  {
    name: 'Essencial',
    description: 'Contrate só os produtos que precisar e ative ou cancele quando quiser, sem fidelidade. Quanto mais produtos, maior o desconto progressivo — aplicado automaticamente.',
    tag: '7 dias grátis',
    products: planProductCards,
    cta: 'Começar agora',
    ctaLink: '/cadastro/?plan=essencial',
  },
  {
    name: 'Enterprise',
    description: 'Para operações maiores que exigem personalização e fluxos sob medida.',
    features: [
      'Personalização e integrações sob medida',
      'AtendaBot integrado a outros sistemas',
      'Atendimento e implantação dedicados',
    ],
    cta: 'Fale com vendas',
    ctaLink: salesWhatsappLink,
    ctaExternal: true,
  },
];

const faqs = [
  {
    question: 'Existe fidelidade mínima?',
    answer:
      'Não. Você continua usando a FoodStation enquanto fizer sentido para a sua operação.',
  },
  {
    question: 'Posso cancelar quando quiser?',
    answer:
      'Sim. A FoodStation não prende você por contrato de fidelidade. Você pode ativar e cancelar produtos quando quiser, sem burocracia.',
  },
  {
    question: 'Como funciona a cobrança dos produtos?',
    answer:
      'Você contrata só os produtos que precisar e a mensalidade é a soma deles. Quanto mais produtos contratados, maior o desconto progressivo. AtendaBot e One Menu formam um único combo de R$ 390 por mês e contam uma vez nessa faixa; CRM e LinkPage não têm custo adicional.',
  },
  {
    question: 'Preciso instalar algum aplicativo?',
    answer:
      'Não. A FoodStation funciona 100% online. Basta acessar pelo navegador e usar normalmente no dia a dia do restaurante.',
  },
  {
    question: 'O atendimento com IA vai responder tudo sozinho?',
    answer:
      'Não. A IA resolve a maior parte das mensagens e encaminha para humanos quando necessário, sempre mantendo o histórico centralizado.',
  },
];

const ProductImageCarousel = ({ images = [], alt }) => {
  const trackRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    let rafId = null;
    const updateActive = () => {
      const items = Array.from(track.children);
      if (!items.length) return;
      const center = track.scrollLeft + track.clientWidth / 2;
      let closestIndex = 0;
      let closestDistance = Infinity;

      items.forEach((item, index) => {
        const itemCenter = item.offsetLeft + item.clientWidth / 2;
        const distance = Math.abs(center - itemCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      setActiveIndex(closestIndex);
    };

    const handleScroll = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(updateActive);
    };

    track.addEventListener('scroll', handleScroll, { passive: true });
    updateActive();

    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      track.removeEventListener('scroll', handleScroll);
    };
  }, [images.length]);

  const handleDotClick = (index) => {
    const track = trackRef.current;
    const target = track?.children?.[index];
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
    setActiveIndex(index);
  };

  if (!images.length) return null;

  return (
    <div className="product-carousel">
      <div className="product-image-stack" ref={trackRef}>
        {images.map((src, index) => (
          <img
            key={src}
            className={`product-image${index === 0 ? ' is-primary' : ' is-secondary'}`}
            src={src}
            alt={alt}
            loading="lazy"
          />
        ))}
      </div>
      {images.length > 1 ? (
        <div className="product-carousel-dots" role="tablist" aria-label="Imagens do produto">
          {images.map((_, index) => (
            <button
              key={`dot-${index}`}
              type="button"
              className={`product-carousel-dot${index === activeIndex ? ' is-active' : ''}`}
              onClick={() => handleDotClick(index)}
              aria-pressed={index === activeIndex}
              aria-label={`Ir para imagem ${index + 1}`}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

const extractYouTubeId = (url) => {
  try {
    const parsed = new URL(url);
    const host = parsed.hostname.replace('www.', '');

    if (host === 'youtu.be') {
      const pathParts = parsed.pathname.split('/').filter(Boolean);
      return pathParts[0];
    }

    if (host === 'youtube.com' || host === 'm.youtube.com') {
      if (parsed.pathname === '/watch') {
        return parsed.searchParams.get('v');
      }

      if (parsed.pathname.startsWith('/embed/')) {
        const pathParts = parsed.pathname.split('/').filter(Boolean);
        return pathParts[1];
      }
    }
  } catch (error) {
    return null;
  }

  return null;
};

const buildVideoPayload = (url) => {
  if (!url) {
    return null;
  }

  const trimmed = url.trim();
  const youtubeId = extractYouTubeId(trimmed);

  if (youtubeId) {
    return {
      type: 'youtube',
      src: `https://www.youtube-nocookie.com/embed/${youtubeId}?rel=0&autoplay=1`,
    };
  }

  return {
    type: 'video',
    src: trimmed,
  };
};

const FoodstationLP = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeVideo, setActiveVideo] = useState(null);
  const [pricingByProduct, setPricingByProduct] = useState({});
  const [pricingStatus, setPricingStatus] = useState('loading');

  useEffect(() => {
    const controller = new AbortController();

    getPublicProductCatalog({ signal: controller.signal })
      .then((response) => {
        const catalog = Array.isArray(response?.data) ? response.data : [];
        const nextPricing = catalog.reduce((result, price) => {
          const key = typeof price?.key === 'string' ? price.key.trim() : '';
          const priceCents = Number(price?.priceCents);
          if (key && Number.isInteger(priceCents) && priceCents >= 0) {
            result[key] = { ...price, priceCents };
          }
          return result;
        }, {});

        setPricingByProduct(nextPricing);
        setPricingStatus(Object.keys(nextPricing).length ? 'loaded' : 'error');
      })
      .catch((error) => {
        if (error?.code !== 'ERR_CANCELED') {
          setPricingStatus('error');
        }
      });

    return () => controller.abort();
  }, []);

  const handleStart = () => {
    setMenuOpen(false);
    navigate('/login');
  };
  const handleMenuToggle = () => setMenuOpen((open) => !open);
  const handleMenuClose = () => setMenuOpen(false);
  const handleVideoOpen = (url) => {
    const payload = buildVideoPayload(url);
    if (payload) {
      setActiveVideo(payload);
    }
  };
  const handleVideoClose = () => setActiveVideo(null);

  return (
    <div className="foodstation-lp">
      <SessionExpiryNotice />
      <nav className={`nav${menuOpen ? ' nav--open' : ''}`}>
        <div className="nav-content">
          <div className="nav-left">
            <a href="#funcionalidades">Como Funciona</a>
            <a href="#produtos">Produtos</a>
            <a href="#incluidos">Grátis</a>
          </div>
          <div className="nav-center">
            <a href="#solucoes">
              <img className="logo-img" src={logo} alt="Foodstation logo" />
            </a>
          </div>
          <div className="nav-right">
            <div className="nav-links">
              <a href="#planos">Planos</a>
              <button type="button" onClick={handleStart}>
                Login
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.14645 3.14645C8.34171 2.95118 8.65829 2.95118 8.85355 3.14645L12.8536 7.14645C13.0488 7.34171 13.0488 7.65829 12.8536 7.85355L8.85355 11.8536C8.65829 12.0488 8.34171 12.0488 8.14645 11.8536C7.95118 11.6583 7.95118 11.3417 8.14645 11.1464L11.2929 8H2.5C2.22386 8 2 7.77614 2 7.5C2 7.22386 2.22386 7 2.5 7H11.2929L8.14645 3.85355C7.95118 3.65829 7.95118 3.34171 8.14645 3.14645Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
            <button
              type="button"
              className="button-menu nav-toggle"
              aria-expanded={menuOpen}
              aria-controls="mobile-menu"
              aria-label={menuOpen ? 'Fechar menu' : 'Abrir menu'}
              onClick={handleMenuToggle}
            >
              <span aria-hidden="true" />
            </button>
          </div>
        </div>
        <div className="nav-mobile" id="mobile-menu">
          <a href="#funcionalidades" onClick={handleMenuClose}>
            Como Funciona
          </a>
          <a href="#produtos" onClick={handleMenuClose}>
            Produtos
          </a>
          <a href="#incluidos" onClick={handleMenuClose}>
            Grátis
          </a>
          <a href="#planos" onClick={handleMenuClose}>
            Planos
          </a>
          <button type="button" onClick={handleStart}>
            Login
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.14645 3.14645C8.34171 2.95118 8.65829 2.95118 8.85355 3.14645L12.8536 7.14645C13.0488 7.34171 13.0488 7.65829 12.8536 7.85355L8.85355 11.8536C8.65829 12.0488 8.34171 12.0488 8.14645 11.8536C7.95118 11.6583 7.95118 11.3417 8.14645 11.1464L11.2929 8H2.5C2.22386 8 2 7.77614 2 7.5C2 7.22386 2.22386 7 2.5 7H11.2929L8.14645 3.85355C7.95118 3.65829 7.95118 3.34171 8.14645 3.14645Z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
      </nav>

      <div className="promo-strip" role="note" aria-label="Oferta">
        <div className="promo-strip__inner">
            <span className="promo-strip__sr">Aproveite 7 dias grátis!</span>
          <div className="promo-strip__track" aria-hidden="true">
            {promoRepeats.map((index) => (
              <span className="promo-strip__item" key={`promo-${index}`}>
                <span>Aproveite 7 dias grátis!</span>
                <span className="promo-strip__divider" aria-hidden="true">•</span>
              </span>
            ))}
          </div>
        </div>
      </div>

      <main>
        <section className="hero" id="solucoes">
          <div className="hero-content">
            <h1>
              Transforme seu Restaurante,
              <br />
              <span className="hero-emphasis">Acelere seu Crescimento</span>
            </h1>
            <p>
              A plataforma completa para atrair clientes, aumentar faturamento e fidelizar, tudo em um só lugar.
            </p>
            <a className="hero-trial-link" href="/cadastro/?plan=essencial">
              Comece agora - 7 dias grátis!
            </a>

          </div>

          <div
            className="logo-slider"
            aria-label="Galeria em movimento"
            style={{ '--slider-card-count': galleryCards.length }}
          >
            <div className="logo-slider__track">
              <div className="logo-slider__group">
                {galleryCards.map((card) => (
                  <div
                    className={['logo-slider__item', card.className].filter(Boolean).join(' ')}
                    key={`logo-${card.alt}`}
                  >
                    <img src={card.src} alt={card.alt} />
                  </div>
                ))}
              </div>
              <div className="logo-slider__group" aria-hidden="true">
                {galleryCards.map((card) => (
                  <div
                    className={['logo-slider__item', card.className].filter(Boolean).join(' ')}
                    key={`logo-dup-${card.alt}`}
                  >
                    <img src={card.src} alt="" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="how-it-works" id="funcionalidades">
          <div className="how-panel">
            <h2 className="how-title">Veja como o Foodstation funciona</h2>
            <div className="how-layout">
              <div className="how-video">
                <button
                  type="button"
                  className="how-video-trigger"
                  onClick={() => handleVideoOpen('https://youtu.be/0-paj4MfYII')}
                  aria-label="Ver vídeo principal Foodstation"
                >
                  <img
                    src="https://img.youtube.com/vi/0-paj4MfYII/hqdefault.jpg"
                    alt=""
                    aria-hidden="true"
                    loading="lazy"
                  />
                  <span className="how-video-play" aria-hidden="true" />
                </button>
                <span className="how-video-label">Vídeo principal Foodstation</span>
              </div>
              <ul className="how-topics">
                <li>
                  <span className="how-topic-icon" aria-hidden="true">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M20 6L9 17l-5-5"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span>Pedidos via WhatsApp, sem erros e sem espera.</span>
                </li>
                <li>
                  <span className="how-topic-icon" aria-hidden="true">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M20 6L9 17l-5-5"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span>Reservas com autonomia para o cliente e controle total.</span>
                </li>
                <li>
                  <span className="how-topic-icon" aria-hidden="true">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M20 6L9 17l-5-5"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span>Feedbacks organizados e centralizados em um painel.</span>
                </li>
                <li>
                  <span className="how-topic-icon" aria-hidden="true">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M20 6L9 17l-5-5"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span>Recrutamento inteligente com triagem automatizada.</span>
                </li>
              </ul>
            </div>
          </div>
        </section>

        <section className="products" id="produtos">
          <div className="products-intro">
            <h2>Produtos Foodstation</h2>
            <p>
              Um ecossistema completo para cada etapa da jornada do restaurante,
              do primeiro contato ao relacionamento contínuo.
            </p>
          </div>
          <div className="products-list">
            {productShowcase.map((product) => (
              <article
                key={product.title}
                id={product.sectionId || (product.anchor ? `produto-${product.anchor}` : undefined)}
                className={`product-card${product.reverse ? ' is-reverse' : ''}`}
                style={{
                  '--product-bg': product.theme.bg,
                  '--product-text': product.theme.text,
                  '--product-muted': product.theme.muted,
                  '--product-card': product.theme.card,
                  '--product-card-border': product.theme.cardBorder,
                  '--product-shadow': product.theme.shadow,
                  '--logo-width-desktop': product.logoWidth,
                  '--logo-margin-desktop': product.logoMarginBottom,
                }}
              >
                {product.layout === 'feature' ? (
                  <div className="product-inner product-inner--feature">
                    <div className="product-content">
                      {product.logo ? (
                        <img
                          className={`product-logo${product.logoClass ? ` ${product.logoClass}` : ''}`}
                          src={product.logo}
                          alt={`${product.title} logo`}
                          loading="lazy"
                        />
                      ) : null}
                      <h3 className="product-headline">{product.headline}</h3>
                      <p className="product-text">{product.description}</p>
                      {product.highlights ? (
                        <ul className="product-highlights">
                          {product.highlights.map((item) => (
                            <li key={item}>{item}</li>
                          ))}
                        </ul>
                      ) : null}
                      {product.included ? (
                        <IncludedProductBadge />
                      ) : (
                        <ProductPrice
                          price={pricingByProduct[product.priceKey]}
                          status={pricingStatus}
                          benefit={product.priceBenefit}
                        />
                      )}
                      <div className="product-actions">
                        <a
                          className="product-cta"
                          href={product.included
                            ? '/cadastro/?plan=essencial'
                            : `/cadastro?produto=${product.signupProductKey}`}
                        >
                          {product.included ? 'Conhecer no teste grátis' : 'Testar 7 dias grátis'}
                        </a>
                        {product.videoUrl ? (
                          <button
                            type="button"
                            className="product-cta product-cta--secondary"
                            onClick={() => handleVideoOpen(product.videoUrl)}
                          >
                            Ver como funciona
                          </button>
                        ) : null}
                      </div>
                    </div>
                    <div className="product-visual">
                      {product.brandVisual ? (
                        <ProductBrandVisual variant={product.brandVisual} />
                      ) : (
                        <ProductImageCarousel images={product.images} alt={product.alt} />
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="product-inner">
                    <div className="product-copy">
                      <h3>{product.title}</h3>
                      <p>{product.description}</p>
                    </div>
                    <div className="product-media">
                      <div className="product-media-inner">
                        <img src={product.image} alt={product.alt} loading="lazy" />
                      </div>
                    </div>
                  </div>
                )}
              </article>
            ))}
          </div>
        </section>

        <section className="plans" id="planos">
          <div className="plans-header">
            <h2>Monte seu plano do seu jeito</h2>
            <p>
              Ative apenas o que precisa. Ao combinar produtos, o desconto progressivo é aplicado automaticamente.
            </p>
          </div>
          <div className="plans-grid">
            {plans.map((plan) => (
              <article
                key={plan.name}
                className={`plan-card${plan.featured ? ' is-featured' : ''}`}
              >
                {plan.featured ? (
                  <span className="plan-badge">Mais escolhido</span>
                ) : plan.tag ? (
                  <span className="plan-badge plan-badge--trial">{plan.tag}</span>
                ) : null}
                <h3>{plan.name}</h3>
                <p className="plan-description">{plan.description}</p>
                {plan.products ? (
                  <div className="plan-product-grid" aria-label={`Produtos do plano ${plan.name}`}>
                    {plan.products.map((product) => {
                      const card = (
                        <div className="plan-product-card">
                          <span
                            className="plan-product-mark"
                            style={{
                              '--plan-product-bg': product.backgroundColor,
                              '--plan-product-logo-size': product.logoSize,
                            }}
                            aria-hidden="true"
                          >
                            <img src={product.image} alt="" loading="lazy" />
                          </span>
                          <span className="plan-product-name">{product.name}</span>
                          {product.anchor ? (
                            <span className="plan-product-arrow" aria-hidden="true">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                <path
                                  d="M7 17L17 7M9 7H17V15"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          ) : null}
                        </div>
                      );

                      if (product.anchor) {
                        return (
                          <a
                            key={product.key}
                            className="plan-product-link"
                            href={`#produto-${product.anchor}`}
                          >
                            {card}
                          </a>
                        );
                      }

                      return (
                        <div key={product.key} className="plan-product-link">
                          {card}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <ul className="plan-features">
                    {(plan.features || []).map((feature) => (
                      <li key={feature} className="plan-feature">
                        {feature}
                      </li>
                    ))}
                  </ul>
                )}
                {(() => {
                  const ctaLink = plan.ctaLink || '/cadastro';
                  const isExternal = plan.ctaExternal || /^https?:\/\//.test(ctaLink);

                  if (isExternal) {
                    return (
                      <a className="plan-cta" href={ctaLink} target="_blank" rel="noopener noreferrer">
                        {plan.cta}
                      </a>
                    );
                  }

                  return (
                    <button
                      type="button"
                      className="plan-cta"
                      onClick={() => navigate(ctaLink)}
                    >
                      {plan.cta}
                    </button>
                  );
                })()}
              </article>
            ))}
          </div>
        </section>

        <section className="faq" id="faq">
          <div className="faq-header">
            <h2>Perguntas frequentes</h2>
          </div>
          <div className="faq-list">
            {faqs.map((item) => (
              <details className="faq-item" key={item.question}>
                <summary>{item.question}</summary>
                <p>{item.answer}</p>
              </details>
            ))}
          </div>
        </section>

      </main>
      <footer className="footer" id="contato">
        <div className="footer-inner">
          <div className="footer-links">
            <h4>Navegação</h4>
            <a href="#solucoes">Soluções</a>
            <a href="#funcionalidades">Como funciona</a>
            <a href="#produtos">Produtos</a>
            <a href="#incluidos">Recursos grátis</a>
            <a href="#planos">Planos</a>
          </div>
          <div className="footer-contact">
            <h4>Contato</h4>
            <p>contato@foodstation.app</p>
            <p>WhatsApp: +55 51 98413-7718</p>
          </div>
        </div>
        <div className="footer-bottom">
          <span>Copyright 2025 Foodstation. Todos os direitos reservados.</span>
          <span className="footer-legal">
            <Link to="/politica-de-privacidade">Política de privacidade</Link>
            <span className="footer-legal-divider">|</span>
            <Link to="/termos-de-uso">Termos</Link>
          </span>
        </div>
      </footer>
      {activeVideo ? (
        <div className="product-video-modal" role="dialog" aria-modal="true">
          <button
            type="button"
            className="product-video-backdrop"
            onClick={handleVideoClose}
            aria-label="Fechar vídeo"
          />
          <div className="product-video-card">
            <button
              type="button"
              className="product-video-close"
              onClick={handleVideoClose}
            aria-label="Fechar vídeo"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            {activeVideo.type === 'youtube' ? (
              <iframe
                src={activeVideo.src}
                title="Vídeo do produto Foodstation"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            ) : (
              <video src={activeVideo.src} controls autoPlay />
            )}
          </div>
        </div>
      ) : null}
      <SupportChat />
    </div>
  );
};

export default FoodstationLP;
